export default "__VITE_ASSET__BfplV27N__"